const list = document.querySelector('#layoutList');
const grid = document.querySelector('#layoutGrid');
const blockProduct = document.querySelector('#product-grid');
const lineProducts = document.querySelectorAll('.grid__item');
const cardProducts = document.querySelectorAll('.card');
const cardWrappers = document.querySelectorAll('.card-wrapper');
const imgProducts = document.querySelectorAll('.card__inner');
const blockTitles = document.querySelectorAll('.pro-title');
const titleProducts = document.querySelectorAll('.product-title');
const desProducts = document.querySelectorAll('.card__content');
const desListProducts = document.querySelectorAll('.description__list');
const blockBuys = document.querySelectorAll('.card-information');
const blockInfos = document.querySelectorAll('div.card__content > .card__information');
const blockTags = document.querySelectorAll('.block_tags_list');
const blockTagsGrid = document.querySelectorAll('.block_tags');
const buttonAdds = document.querySelectorAll('.cart_button');
const blockPrices = document.querySelectorAll('.price');



window.addEventListener("DOMContentLoaded", () => {
    if (localStorage.getItem('display') == "list") {

        grid.classList.remove('current');
        list.classList.add('current');

        blockProduct.classList.remove('product-grid');
        blockProduct.classList.add('grid__list-view');

        lineProducts.forEach((element) => {
            element.classList.remove('grid__item');
            element.classList.add('grid__item--list');
        });
        cardProducts.forEach((element) => {
            element.classList.add('card-product__list');
        });
        cardWrappers.forEach((element) => {
            element.classList.add('card-wrapper__list');
        });
        imgProducts.forEach((element) => {
            element.classList.add('card__inner--list');
        });
        blockTitles.forEach((element) => {
            element.style.minHeight = 'auto';
        });
        titleProducts.forEach((element) => {
            element.style.fontSize = '20px';
        });
        desProducts.forEach((element) => {
            element.classList.remove('card__content');
            element.classList.add('card__content--list');
        });
        desListProducts.forEach((element) => {
            element.classList.remove('hidden');
        });
        blockBuys.forEach((element) => {
            element.classList.add('card-information__list');
        });
        blockInfos.forEach((element) => {
            element.style.display = 'block';
        });
        blockTags.forEach((element) => {
            element.classList.remove('block_tags_list');
            element.classList.add('block_tags_list-change');
        });
        blockTagsGrid.forEach((element) => {
            element.classList.add('block_tags_hidden');
        });
        buttonAdds.forEach((element) => {
            element.classList.remove('cart_button');
            element.classList.add('cart_button--list');
        });
        blockPrices.forEach((element) => {
            element.classList.add('price__list');
        });
    };
});



list.addEventListener('click', function () {

    if (localStorage.getItem('display') == null || localStorage.getItem('display') == 'grid') {

        localStorage.setItem("display", "list");

        grid.classList.remove('current');
        list.classList.add('current');

        blockProduct.classList.remove('product-grid');
        blockProduct.classList.add('grid__list-view');

        lineProducts.forEach((element) => {
            element.classList.remove('grid__item');
            element.classList.add('grid__item--list');
        });
        cardProducts.forEach((element) => {
            element.classList.add('card-product__list');
        });
        cardWrappers.forEach((element) => {
            element.classList.add('card-wrapper__list');
        });
        imgProducts.forEach((element) => {
            element.classList.add('card__inner--list');
        });
        blockTitles.forEach((element) => {
            element.style.minHeight = 'auto';
        });
        titleProducts.forEach((element) => {
            element.style.fontSize = '20px';
        });
        desProducts.forEach((element) => {
            element.classList.remove('card__content');
            element.classList.add('card__content--list');
        });
        desListProducts.forEach((element) => {
            element.classList.remove('hidden');
        });
        blockBuys.forEach((element) => {
            element.classList.add('card-information__list');
        });
        blockInfos.forEach((element) => {
            element.style.display = 'block';
        });
        blockTags.forEach((element) => {
            element.classList.remove('block_tags_list');
            element.classList.add('block_tags_list-change');
        });
        blockTagsGrid.forEach((element) => {
            element.classList.add('block_tags_hidden');
        });
        buttonAdds.forEach((element) => {
            element.classList.remove('cart_button');
            element.classList.add('cart_button--list');
        });
        blockPrices.forEach((element) => {
            element.classList.add('price__list');
        });

    }

});



grid.addEventListener('click', function () {

    if (localStorage.getItem('display') == 'list') {

        localStorage.setItem("display", "grid");

        list.classList.remove('current');
        grid.classList.add('current');

        blockProduct.classList.remove('grid__list-view');
        blockProduct.classList.add('product-grid');

        lineProducts.forEach((element) => {
            element.classList.remove('grid__item--list');
            element.classList.add('grid__item');
        });
        cardProducts.forEach((element) => {
            element.classList.remove('card-product__list');
        });
        cardWrappers.forEach((element) => {
            element.classList.remove('card-wrapper__list');
        });
        imgProducts.forEach((element) => {
            element.classList.remove('card__inner--list');
        });
        blockTitles.forEach((element) => {
            element.style.minHeight = '50px';
        });
        titleProducts.forEach((element) => {
            element.style.fontSize = '14px';
        });
        desProducts.forEach((element) => {
            element.classList.remove('card__content--list');
            element.classList.add('card__content');
        });
        desListProducts.forEach((element) => {
            element.classList.add('hidden');
        });
        blockBuys.forEach((element) => {
            element.classList.remove('card-information__list');
        });
        blockInfos.forEach((element) => {
            element.style.display = 'block';
        });
        blockTags.forEach((element) => {
            element.classList.remove('block_tags_list-change');
            element.classList.add('block_tags_list');
        });
        blockTagsGrid.forEach((element) => {
            element.classList.remove('block_tags_hidden');
        });
        buttonAdds.forEach((element) => {
            element.classList.remove('cart_button--list');
            element.classList.add('cart_button');
        });
        blockPrices.forEach((element) => {
            element.classList.remove('price__list');
        });

    }

});
